/* =============================================================================
   Fitment finder — search a car, show its specs, match wheels from the range.
   Scoring logic carried over from v2 (unchanged maths), rebuilt as a module.
============================================================================= */
(function () {
  'use strict';
  var W = window.WWC;
  var root = document.querySelector('[data-fitment]');
  if (!root || !W) return;

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var esc = W.esc;
  var DATA = null, INDEX = [], current = null, style = 'street', filter = 'all';
  var products = { flow: null, forged: null };
  var status = $('[data-ff-status]');

  /* ---------- helpers (same maths as v2, shared in global.js) ---------- */
  var normPCD = W.fit.normPCD, parseVariant = W.fit.parseVariant;
  function target(d) { return W.fit.target(d, style); }
  function scoreFlow(p, tgt, pcd) {
    var best = null;
    p.variants.forEach(function (v) {
      var sp = parseVariant(v, p);
      if (!sp.pcd || normPCD(sp.pcd) !== pcd) return; // bolt pattern must match
      var cost = 0;
      cost += sp.width != null ? Math.abs(sp.width - tgt.w) * 8 : 6;
      cost += sp.et != null ? Math.abs(sp.et - tgt.et) * 1.2 : 5;
      cost += sp.dia != null ? Math.abs(sp.dia - tgt.dia) * 5 : 6;
      if (!best || cost < best.cost) best = { cost: cost, variant: v, sp: sp };
    });
    if (!best) return null;
    best.score = Math.max(55, Math.min(100, Math.round(100 - best.cost * 1.5)));
    return best;
  }

  /* ---------- data ---------- */
  function loadProducts(kind) {
    var handle = root.dataset[kind];
    if (!handle) return Promise.resolve([]);
    if (products[kind]) return Promise.resolve(products[kind]);
    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { products[kind] = d.products || []; return products[kind]; })
      .catch(function () { return []; });
  }

  var selects = W.vehicleSelects($('[data-ff-form]'));

  W.loadFitment().then(function (d) {
    DATA = d;
    Object.keys(d.DB).forEach(function (mk) {
      Object.keys(d.DB[mk]).forEach(function (md) {
        Object.keys(d.DB[mk][md]).forEach(function (yr) {
          INDEX.push({ make: mk, model: md, year: yr, hay: (mk + ' ' + md + ' ' + yr).toLowerCase() });
        });
      });
    });
    selects.ensure();
    renderPopular('all');
    // Deep link from the header bar / shared URL
    var q = new URLSearchParams(location.search);
    var mk = q.get('make'), md = q.get('model'), yr = q.get('year');
    if (mk) {
      selects.set({ make: mk, model: md, year: yr }).then(function () {
        if (md && d.DB[mk] && d.DB[mk][md]) show(mk, md, yr || Object.keys(d.DB[mk][md])[0], true);
      });
    }
  }).catch(function () {
    status.textContent = 'The fitment list didn’t load. Refresh the page, or request a quote below and we’ll spec your car by hand.';
  });

  /* ---------- popular chips ---------- */
  function renderPopular(cat) {
    var cats = $('[data-ff-cats]'), chips = $('[data-ff-chips]');
    cats.innerHTML = DATA.CAT_LABELS.map(function (c) {
      return '<button type="button" class="chip" aria-pressed="' + (c[0] === cat) + '" data-cat="' + c[0] + '">' + esc(c[1]) + '</button>';
    }).join('');
    chips.innerHTML = DATA.POPULAR.filter(function (p) { return cat === 'all' || p.cat.indexOf(cat) > -1; }).map(function (p) {
      return '<button type="button" class="chip" data-mk="' + esc(p.mk) + '" data-md="' + esc(p.md) + '">' + esc(p.mk + ' ' + p.md) + '</button>';
    }).join('');
  }
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-cat]');
    if (c) { renderPopular(c.dataset.cat); return; }
    var p = e.target.closest('[data-mk]');
    if (p) {
      var yrs = Object.keys(DATA.DB[p.dataset.mk][p.dataset.md]);
      selects.set({ make: p.dataset.mk, model: p.dataset.md, year: yrs[0] });
      show(p.dataset.mk, p.dataset.md, yrs[0]);
    }
  });

  /* ---------- search with suggestions (combobox) ---------- */
  var qIn = $('[data-ff-q]'), sug = $('[data-ff-sug]'), active = -1, matches = [];
  function closeSug() { sug.hidden = true; qIn.setAttribute('aria-expanded', 'false'); active = -1; qIn.removeAttribute('aria-activedescendant'); }
  qIn.addEventListener('input', W.debounce(function () {
    var q = qIn.value.trim().toLowerCase();
    if (!DATA || q.length < 2) { closeSug(); return; }
    var terms = q.split(/\s+/);
    matches = INDEX.filter(function (x) { return terms.every(function (t) { return x.hay.indexOf(t) > -1; }); }).slice(0, 8);
    sug.innerHTML = matches.length ? matches.map(function (m, i) {
      return '<li role="option" id="ff-opt-' + i + '" data-i="' + i + '"><strong>' + esc(m.make + ' ' + m.model) + '</strong><span>' + esc(m.year) + '</span></li>';
    }).join('') : '<li class="ff-suggest__empty">No match — try the model code (e.g. “G80”), or request a quote below.</li>';
    sug.hidden = false; qIn.setAttribute('aria-expanded', 'true'); active = -1;
  }, 120));
  qIn.addEventListener('keydown', function (e) {
    if (sug.hidden || !matches.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      active = (active + (e.key === 'ArrowDown' ? 1 : -1) + matches.length) % matches.length;
      $$('[data-ff-sug] [role="option"]').forEach(function (o, i) { o.setAttribute('aria-selected', i === active); });
      qIn.setAttribute('aria-activedescendant', 'ff-opt-' + active);
    } else if (e.key === 'Enter') { e.preventDefault(); pick(active < 0 ? 0 : active); }
    else if (e.key === 'Escape') closeSug();
  });
  sug.addEventListener('mousedown', function (e) { var li = e.target.closest('[data-i]'); if (li) { e.preventDefault(); pick(+li.dataset.i); } });
  qIn.addEventListener('blur', function () { setTimeout(closeSug, 120); });
  function pick(i) {
    var m = matches[i]; if (!m) return;
    qIn.value = m.make + ' ' + m.model; closeSug();
    selects.set(m); show(m.make, m.model, m.year);
  }

  $('[data-ff-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var v = selects.get();
    if (!v.make || !v.model || !v.year) { status.textContent = 'Choose a make, model and year first.'; return; }
    show(v.make, v.model, v.year);
  });

  /* ---------- result ---------- */
  function wheelStr(o) { return o.d + '×' + o.w + 'J ET' + o.et; }
  // Sets we have built for this car. The offset stays in the page but is blurred: customers ask us for it.
  function renderBuilds(d, car) {
    var box = $('[data-ff-builds]'); if (!box) return;
    var list = d.builds || [];
    box.hidden = !list.length;
    if (!list.length) { box.innerHTML = ''; return; }
    var ql = $('[data-ff-quote-link]'), base = ql ? ql.getAttribute('href').split('?')[0].split('#')[0] : '/pages/contact-us';
    var size = function (s) { return s.d + '×' + s.w + 'J'; };
    box.innerHTML = '<h4>Sets we\u2019ve built for this car</h4>' +
      '<p class="ff-builds__lead">Real WheelWork forged builds. Exact offsets are on request: we confirm them against your car.</p>' +
      '<ul class="ff-builds__list" role="list">' + list.map(function (b) {
        var sz = size(b.f) + (b.r ? ' / ' + size(b.r) : ''), et = 'ET' + b.f.et + (b.r ? ' / ET' + b.r.et : '');
        var meta = [b.finish, b.kg ? b.kg + ' kg per wheel' : '', b.load ? 'rated ' + b.load + ' kg' : ''].filter(Boolean).join(' · ');
        var href = base + '?vehicle=' + encodeURIComponent(car) + '&product=' + encodeURIComponent('Forged build like ' + sz + (b.finish ? ', ' + b.finish : '')) + '#quote';
        return '<li class="ff-build"><div><p class="ff-build__size">' + esc(sz) + (b.r ? ' <small>front / rear</small>' : '') + '</p>' +
          '<p class="ff-build__meta">Offset <span class="wwc-gate" title="Ask us for the exact offset">' + esc(et) + '</span>' + (meta ? ' · ' + esc(meta) : '') + '</p></div>' +
          '<a class="btn btn--secondary btn--sm" href="' + href + '">Quote me this</a></li>';
      }).join('') + '</ul>';
  }
  function show(mk, md, yr, fromUrl) {
    var d = DATA.DB[mk] && DATA.DB[mk][md] && DATA.DB[mk][md][yr];
    if (!d) return;
    current = { make: mk, model: md, year: yr, d: d };
    status.textContent = 'Showing fitment for ' + mk + ' ' + md + ', ' + yr + '.';
    var res = $('[data-ff-result]');
    $('[data-ff-title]').textContent = mk + ' ' + md;
    $('[data-ff-sub]').textContent = yr;
    var stag = wheelStr(d.stockF) !== wheelStr(d.stockR);
    $('[data-ff-specs]').innerHTML = [
      ['Bolt pattern (PCD)', d.bolt], ['Centre bore', d.bore], ['Thread', d.stud + (d.seat ? ' · ' + d.seat + ' seat' : '')],
      ['Stock front', wheelStr(d.stockF)], ['Stock rear', stag ? wheelStr(d.stockR) : 'Same as front'],
      ['Stock tyres', d.tyreF ? (d.tyreR && d.tyreR !== d.tyreF ? d.tyreF + ' / ' + d.tyreR : d.tyreF) : '—']
    ].map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
    $('[data-ff-table]').innerHTML = '<thead><tr><th scope="col">Style</th><th scope="col">Diameter</th><th scope="col">Width</th><th scope="col">Offset</th></tr></thead><tbody>' +
      '<tr><td><span class="badge badge--success">OEM+</span></td><td>' + d.stockF.d + '"</td><td>' + d.stockF.w + 'J</td><td>ET' + d.stockF.et + '</td></tr>' +
      '<tr class="is-hl"><td><span class="badge">Street</span></td><td>' + esc(d.street.d) + '</td><td>' + esc(d.street.w) + '</td><td>' + esc(d.street.et) + '</td></tr>' +
      '<tr><td><span class="badge badge--warn">Aggressive</span></td><td>' + esc(d.agg.d) + '</td><td>' + esc(d.agg.w) + '</td><td>' + esc(d.agg.et) + '</td></tr></tbody>';
    $('[data-ff-note]').innerHTML = d.note ? '<strong>Fitment note:</strong> ' + esc(d.note) : '';
    renderBuilds(d, mk + ' ' + md + ' (' + yr + ')');
    res.hidden = false;

    // keep quote + WhatsApp links carrying the car
    var car = mk + ' ' + md + ' (' + yr + ')';
    var ql = $('[data-ff-quote-link]');
    if (ql) { var u = new URL(ql.getAttribute('href'), location.origin); u.searchParams.set('vehicle', car); ql.href = u.pathname + u.search; }
    var wa = $('[data-ff-wa]');
    if (wa && W.whatsapp) wa.href = 'https://wa.me/' + W.whatsapp + '?text=' + encodeURIComponent('Hi Wheelwork, I’d like wheels for my ' + car + '.');
    if (!fromUrl) history.replaceState(null, '', location.pathname + '?' + new URLSearchParams({ make: mk, model: md, year: yr }).toString() + '#fitment');

    // let the wheel visualiser (and anything else) know which car is selected
    document.dispatchEvent(new CustomEvent('wwc:vehicle', { detail: { make: mk, model: md, year: yr, data: d } }));
    res.focus({ preventScroll: true });
    res.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    recommend();
  }

  $('[data-ff-copy]').addEventListener('click', function (e) {
    if (!current) return;
    var d = current.d;
    var text = current.make + ' ' + current.model + ' ' + current.year + '\nPCD ' + d.bolt + ' · CB ' + d.bore + ' · ' + d.stud +
      '\nStock ' + wheelStr(d.stockF) + (wheelStr(d.stockF) !== wheelStr(d.stockR) ? ' / ' + wheelStr(d.stockR) : '') +
      '\nStreet ' + d.street.d + ' ' + d.street.w + ' ' + d.street.et + '\nAggressive ' + d.agg.d + ' ' + d.agg.w + ' ' + d.agg.et + '\n— wheelworkcustoms.com';
    e.currentTarget.setAttribute('data-copy', text);
  }, true);
  $('[data-ff-garage]').addEventListener('click', function (e) {
    if (!current) return;
    W.setGarage({ make: current.make, model: current.model, year: current.year });
    e.currentTarget.textContent = 'Saved to my garage';
  });

  /* ---------- recommendations ---------- */
  $('[data-ff-style]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-style]'); if (!b) return;
    style = b.dataset.style;
    $$('[data-ff-style] [role="radio"]').forEach(function (x) { x.setAttribute('aria-checked', x === b); });
    recommend();
  });
  function setFilter(f) {
    filter = f;
    $$('[data-ff-filter] .chip').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.filter === f); });
    render();
  }
  $('[data-ff-filter]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-filter]'); if (!b) return;
    setFilter(b.dataset.filter);
  });
  // "Get this exact fit in forged": jump to the forged designs for this car
  var forgedBtn = $('[data-ff-forged]');
  if (forgedBtn) forgedBtn.addEventListener('click', function () {
    if (current) setFilter('forged');
    $('[data-ff-recs]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var recs = { flow: [], forged: [], tgt: null };
  function recommend() {
    var wrap = $('[data-ff-recs]'); wrap.hidden = false;
    var grid = $('[data-ff-grid]');
    grid.innerHTML = '<li class="ff-loading" aria-busy="true"><span></span><span></span><span></span><span></span></li>';
    Promise.all([loadProducts('flow'), loadProducts('forged')]).then(function (r) {
      var d = current.d, tgt = target(d), pcd = normPCD(d.bolt);
      recs.tgt = tgt;
      recs.flow = r[0].map(function (p) { var m = scoreFlow(p, tgt, pcd); return m ? { p: p, m: m } : null; })
        .filter(Boolean).sort(function (a, b) { return b.m.score - a.m.score; }).slice(0, 12);
      recs.forged = r[1].slice(0, 12);
      var label = { oem: 'OEM+', street: 'Street', agg: 'Aggressive' }[style];
      // Forged leads: every design is machined to the car, so it is always the recommended fit
      $('[data-ff-recs-sub]').innerHTML = '<strong>Recommended: custom forged.</strong> ' + recs.forged.length + ' forged designs, each machined to your <strong>' + esc(d.bolt) + '</strong> bolt pattern and the exact width and offset for your ' + esc(current.model) + '. ' + label + ' target ≈ ' + tgt.dia.toFixed(0) + '×' + tgt.w.toFixed(1) + 'J ET' + Math.round(tgt.et) + '.' +
        (recs.flow.length ? ' Also ' + recs.flow.length + ' flow-formed ' + (recs.flow.length === 1 ? 'wheel' : 'wheels') + ' in stock in your bolt pattern.' : '');
      render();
    });
  }

  function img(p) {
    var src = p.images && p.images[0] && p.images[0].src;
    return src ? '<img src="' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600" srcset="' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400 400w, ' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700 700w" sizes="(min-width:1200px) 25vw, 50vw" alt="' + esc(p.title) + '" width="600" height="600" loading="lazy">' : '';
  }
  function price(v) { return W.money(Math.round(parseFloat(v) * 100)); }

  function render() {
    var grid = $('[data-ff-grid]'), html = '';
    var qty = parseInt(root.dataset.qty, 10) || 4;
    var car = current.make + ' ' + current.model + ' (' + current.year + ')';
    if (filter !== 'flow') recs.forged.forEach(function (p) {
      var min = Math.min.apply(null, p.variants.map(function (v) { return parseFloat(v.price); }));
      var url = '/products/' + p.handle + '?vehicle=' + encodeURIComponent(car) + '&dia=' + Math.round(recs.tgt.dia);
      html += '<li><article class="card ff-card">' +
        '<div class="card__media">' + img(p) + '<div class="card__badges"><span class="badge badge--accent">Recommended · 100% fit</span></div></div>' +
        '<div class="card__body"><span class="card__vendor">Custom forged · made to your car</span>' +
        '<h4 class="card__title"><a href="' + url + '">' + esc(p.title) + '</a></h4>' +
        '<span class="card__price"><span class="price"><span class="price__from">From</span><span class="price__now">' + price(min) + '</span><span class="price__unit">per wheel</span></span></span>' +
        '<span class="card__meta">Machined to ' + esc(current.d.bolt) + ' · ' + Math.round(recs.tgt.dia) + '" suggested</span>' +
        '<span class="btn btn--block ff-card__btn" aria-hidden="true">Build for my car</span>' +
        '</div></article></li>';
    });
    if (filter !== 'forged') recs.flow.forEach(function (r) {
      var p = r.p, m = r.m, cls = m.score >= 90 ? 'badge--success' : m.score >= 72 ? '' : 'badge--warn';
      var label = m.score >= 90 ? 'Exact match' : m.score >= 72 ? 'Near match' : 'Fits — check look';
      var opts = p.variants.filter(function (v) { var s = parseVariant(v, p); return s.pcd && normPCD(s.pcd) === normPCD(current.d.bolt); })
        .map(function (v) { return '<option value="' + v.id + '"' + (v.id === m.variant.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + ' — ' + price(v.price) + (v.available ? '' : ' (sold out)') + '</option>'; }).join('');
      html += '<li><article class="card ff-card">' +
        '<div class="card__media">' + img(p) + '<div class="card__badges"><span class="badge ' + cls + '">' + m.score + '% · ' + label + '</span></div></div>' +
        '<div class="card__body"><span class="card__vendor">Flow-formed · in stock</span>' +
        '<h4 class="card__title"><a href="/products/' + p.handle + '" style="position:relative;z-index:3">' + esc(p.title) + '</a></h4>' +
        '<span class="card__price"><span class="price"><span class="price__now">' + price(m.variant.price) + '</span><span class="price__unit">per wheel</span></span></span>' +
        '<label class="visually-hidden" for="ffv-' + p.id + '">Size for ' + esc(p.title) + '</label>' +
        '<select class="select ff-card__select" id="ffv-' + p.id + '" data-variant>' + opts + '</select>' +
        '<button type="button" class="btn btn--secondary btn--block ff-card__btn" data-add data-car="' + esc(car) + '" data-qty="' + qty + '">Add set of ' + qty + ' to cart</button>' +
        '</div></article></li>';
    });
    grid.innerHTML = html || '<li class="empty-state" style="grid-column:1/-1">No wheels in this filter yet. Request a quote below — we build forged sets for any bolt pattern.</li>';
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]'); if (!b) return;
    var sel = b.parentNode.querySelector('[data-variant]');
    if (!sel || !sel.value) return;
    b.classList.add('is-loading');
    W.addToCart([{ id: +sel.value, quantity: +b.dataset.qty, properties: { Vehicle: b.dataset.car, 'Fitment style': style } }])
      .catch(function (err) { W.toast(esc(err.message)); })
      .finally(function () { b.classList.remove('is-loading'); });
  });
})();
